import { render } from "./MainClient.vue?vue&type=template&id=29e54a72&scoped=true"
import script from "./MainClient.vue?vue&type=script&lang=js"
export * from "./MainClient.vue?vue&type=script&lang=js"

import "./MainClient.vue?vue&type=style&index=0&id=29e54a72&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29e54a72"]])

export default __exports__